import { 
    Datagrid, EditButton,
    SearchInput, SimpleForm, Create, TextField, TextInput,
    useNotify, useRedirect, Edit, TopToolbar, 
    CreateButton, ExportButton, List} from "react-admin";
import { CustomPagination, required } from './util/generic'
import { ItasToolbar } from "./util/ItasToolbar";
import { ItasEditActions } from "./util/ItasEditActions"
   
  
  const personeFilter = [
    <SearchInput placeholder="Cerca" source="q" alwaysOn />,
  ];

  export const PersoneForm = (customToolbar) => {
      return (
        <SimpleForm 
          mode="onBlur" 
          reValidateMode="onBlur"
          toolbar={<ItasToolbar />}>
          <TextInput source="nome" validate={required()} fullWidth/>
          <TextInput source="indirizzo" validate={required()} fullWidth/>
          <TextInput source="citta" validate={required()} fullWidth/>
          <TextInput source="cap" validate={required()} fullWidth />
          <TextInput source="provincia" validate={required()} fullWidth />
          <TextInput source="email"  fullWidth />
          <TextInput source="telefono1" fullWidth />
          <TextInput source="telefono2"  fullWidth />
          <TextInput source="fax"  fullWidth />
          <TextInput source="piva"  fullWidth />
          <TextInput source="cf"  fullWidth />
          <TextInput source="note"  fullWidth />
        </SimpleForm>
    )
  }
  export const PersoneCreate = () => {
    const notify = useNotify();
    const redirect = useRedirect();
  
    const onSuccess = (data) => {
        notify(`Persona aggiunta`, { type: 'success' });
        redirect(`/persone`);
    };
    return (
      <Create 
        mutationOptions={{ onSuccess }}
        title="Aggiungi nuova persona">
        <ItasEditActions />
        <PersoneForm />
      </Create>
    );
  }
  
  
  
  export const PersoneEdit = () => {
    const notify = useNotify();
    const redirect = useRedirect();
  
    const onSuccess = (data) => {
        notify(`Persona aggiornata!`, { type: 'success' });
        redirect(`/persone`);
    };
    const onDelete = (data) => {
      notify(`Persona eliminata!`, { type: 'success' });
      redirect(`/persone`);
  };
    return (
      <Edit mutationOptions={{ onSuccess, onDelete }}
            actions={<ItasEditActions />}
            mutationMode="optimistic"
            title="Modifica dettagli persona"
            >

        <PersoneForm />
      </Edit>
    );
  }
  const ListActions = () => (
    <TopToolbar>
        <CreateButton label="Crea persona"/>
        <ExportButton label="Esporta dati" maxResults={10000}/>
    </TopToolbar>
  );
  
  export const PersoneList = () => (
    <List 
      sort={{ field: 'nome', order: 'ASC' }}
      filters={personeFilter} 
      pagination={<CustomPagination />}
      perPage={12}
      actions={<ListActions />}
    >
      <Datagrid>
        <TextField source="nome" />
        <TextField source="indirizzo" />
        <TextField label="Città" source="citta" />
        <TextField source="cap" />
        <TextField source="provincia" />
        <TextField source="email" />
        <TextField source="telefono1" />
        <TextField source="telefono2" />
        <TextField source="fax" />
        <TextField source="piva" />
        <TextField label="CF" source="cf" />
        <TextField source="note" />
        <EditButton label=""/>
      </Datagrid>
    </List>
  );